import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './styles/global.css';
import { register } from './serviceWorkerRegistration';
import NetworkProvider from './context/NetworkProvider';
import { useTokenStore } from './storage/tokenState';
import { setAuthTokenInHeader } from './api';
import { bootstrapKycReturn } from './pages/Kyc/bootstrapKycReturn';

/**
 * Restore the auth header before anything can make a request.
 *
 * The token is persisted to localStorage, but the axios instance is not — its
 * `authorization` header is only ever set by sign-in, by silent login once it
 * resolves, or by a token refresh. So on a cold page load every request fired
 * before silent login round-trips goes out unauthenticated, 401s, and can take
 * the refresh path all the way to `logout()` and a hard redirect to '/'.
 *
 * That is not hypothetical: returning from DigiLocker is always a cold load, and
 * completion fires on mount.
 *
 * zustand-persist rehydrates synchronously from localStorage, so the token is
 * already readable here — before render, before any component effect.
 */
const persistedToken = useTokenStore.getState().token;
if (persistedToken?.accessToken) {
  setAuthTokenInHeader(persistedToken.accessToken, persistedToken._id);
}

/**
 * A DigiLocker return is resolved before the app mounts — parking the clientId
 * out of the query string, and, on the callback path, handing off without ever
 * booting the SPA there. See `bootstrapKycReturn` for why this cannot be a route.
 */
const kycReturnHandled = bootstrapKycReturn();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
if (!kycReturnHandled) {
  root.render(
    <React.StrictMode>
      <NetworkProvider>
        <App />
      </NetworkProvider>
    </React.StrictMode>
  );
}

// Register the service worker for production environments
register();
// if (process.env.NODE_ENV === 'production') {
// }
